import { Routes } from '@angular/router';
import { AuthGuard } from '@core/shared';
import { LeaderboardComponent } from './leaderboard.component';
import { ThreemcarcareLeaderboardComponent } from './component/threemcarcare/threemcarcare.component';
import { SelectPartnerLeaderboardComponent } from './component/selectpartner/selectpartner.component';

export const LeaderboardRoutes: Routes = [

    {
        path: 'leaderboard',
        component: LeaderboardComponent,
        children: [
            {
                path: 'threemcarcare',
                canActivate: [AuthGuard],
                component: ThreemcarcareLeaderboardComponent,
                pathMatch: 'full',
                data: { title: 'Leaderboard - 3m', isPreLogin: false }
            },
            {
                path: 'selectpartner',
                canActivate: [AuthGuard],
                component: SelectPartnerLeaderboardComponent,
                pathMatch: 'full',
                data: { title: 'Leaderboard - Select Partner', isPreLogin: false }
            }
        ]
    }
];